export default "__VITE_ASSET__Cdzf7Ppr__"